<template>
  <div>
    <a href="javascript:void(0)" @click="openForm" title="Edit email">{{ email }}</a>
    <div class="modal fade" id="editIRModal" ref="editIRModal" tabindex="-1" role="dialog" aria-hidden="true" style="background: rgba(0,0,0,0.7);">
      <div class="modal-dialog modal-dialog-centered" style="width: 100%; max-width:780px; margin-top: 30px; margin-bottom: 30px;">
        <div class="modal-content">
          <div class="modal-header">
            <h3 style="color: #000; font-size: 22px; padding: 0; margin: 0; text-align: center;">Edit Email</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body clearfix" style="padding: 20px 30px 30px;">
            <form @submit.prevent="submit">
              <div class="form-group">
                  <label for="old-email">Old Email</label>
                  <input id="old-email" class="form-control" type="email" :value="email" disabled />
              </div>
              <div class="form-group">
                <label for="new_email">New Email</label>
                <input v-model="newEmail" id="new-email" class="form-control" type="email" />
              </div>
              <div class="form-group d-flex justify-content-end">
                <button class="btn btn-secondary" :disabled="!newEmail.length">Save</button>
              </div>
            </form>
            <div v-if="success" class="alert alert-success mt-3" role="alert">
              <p class="mb-0">Email Updated</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IncentiveRegistrationService from '../services/incentive-registration.service';
import FormMixin from '../mixins/FormMixin';

export default {
  props: {
    email: {
      type: String,
      default: ''
    },
    incentiveRegistrationId: {
      type: String
    }
  },
  mixins: [
    FormMixin,
  ],
  data() {
    return {
      newEmail: ''
    }
  },
  methods: {
    openForm() {
      $(this.$refs.editIRModal).modal('show');
    },
    async submit() {
      this.success = false;
      this.pending = true;
      this.errorMessage = '';
      this.validationErrors = {};

      try {
        const response = await IncentiveRegistrationService.updateEmail(this.incentiveRegistrationId, { email: this.newEmail});
        this.success = true;

        setTimeout(() => {
          this.newEmail = '';
          this.success = false;
          $(this.$refs.editIRModal).modal('hide');
          window.location = response.redirect;
        }, 3000);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pending = false;
      }
    },
  }
}
</script>